<template>
  <div class="first-steps-container">
    <v-icon large class="back-button" @click="backToDash">{{
      $config.icons.backButton
    }}</v-icon>
    <div class="first-steps-container01">
      <h1 class="first-steps-title">Seja Bem-Vindo!</h1>
      <span class="first-steps-subtitle">
        Prepare-se para começar a vender online.
        <br />
      </span>
      <div class="first-steps-container02">
        <div
          :class="
            hasRegisterData
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('cadastro-loja')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasRegisterData"
              >
                <path
                  d="M229.714 404l282.286 174.286-195.429 162.857-280-182.286zM793.143 721.143v61.714l-280 167.429v0.571l-0.571-0.571-0.571 0.571v-0.571l-279.429-167.429v-61.714l84 54.857 195.429-162.286v-1.143l0.571 0.571 0.571-0.571v1.143l196 162.286zM316.571 67.429l195.429 162.857-282.286 173.714-193.143-154.286zM794.286 404l193.143 154.857-279.429 182.286-196-162.857zM708 67.429l279.429 182.286-193.143 154.286-282.286-173.714z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line1"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Cadastro</h1>
            <span class="first-steps-text05">
              <span v-if="!hasRegisterData"
                >Adicione os dados cadastrais da loja.</span
              >
              <span v-else>Dados cadastrais adicionados.</span>
              <br />
            </span>
          </div>
        </div>
        <div
          :class="
            hasReceiveData
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('recebimentos-loja')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line2"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasReceiveData"
              >
                <path
                  d="M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line1"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Recebimento</h1>
            <span class="first-steps-text05">
              <span v-if="!hasReceiveData"
                >Defina as informações de recebimento.</span
              >
              <span v-else>Informações de recebimento definidas.</span>
              <br />
            </span>
          </div>
        </div>
        <div
          :class="
            hasPaymentData
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('pagamentos-loja')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line2"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasPaymentData"
              >
                <path
                  d="M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line1"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Pagamento</h1>
            <span class="first-steps-text05">
              <span v-if="!hasPaymentData"
                >Defina as informações de pagamento.</span
              >
              <span v-else>Informações de pagamento definidas.</span>
              <br />
            </span>
          </div>
        </div>
        <div
          :class="
            hasThemeData
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('tema-loja')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line2"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasThemeData"
              >
                <path
                  d="M746 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM618 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM406 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM278 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM512 128q158 0 271 100t113 242q0 88-63 150t-151 62h-74q-28 0-46 19t-18 45q0 22 16 42t16 44q0 28-18 46t-46 18q-160 0-272-112t-112-272 112-272 272-112z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line1"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Tema</h1>
            <span class="first-steps-text05">
              <span v-if="!hasThemeData">Dê um visual para a sua loja.</span>
              <span v-else>Tema da loja definido.</span>
              <br />
            </span>
          </div>
        </div>
        <div
          :class="
            hasPlusConfigData
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('configs-loja')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line2"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasPlusConfigData"
              >
                <path
                  d="M746 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM618 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM406 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM278 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM512 128q158 0 271 100t113 242q0 88-63 150t-151 62h-74q-28 0-46 19t-18 45q0 22 16 42t16 44q0 28-18 46t-46 18q-160 0-272-112t-112-272 112-272 272-112z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line1"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Configurações</h1>
            <span class="first-steps-text05">
              <span v-if="!hasPlusConfigData"
                >Defina as configurações da loja.</span
              >
              <span v-else>Configurações da loja definidas.</span>
              <br />
            </span>
          </div>
        </div>
        <div
          :class="
            hasProduct
              ? 'first-steps-step non-clickable'
              : 'first-steps-step clickable'
          "
          @click="goTo('produto')"
        >
          <div class="first-steps-container03">
            <div class="first-steps-line2"></div>
            <div class="first-steps-container04">
              <svg
                viewBox="0 0 1024 1024"
                class="first-steps-icon"
                v-if="!hasProduct"
              >
                <path
                  d="M229.714 404l282.286 174.286-195.429 162.857-280-182.286zM793.143 721.143v61.714l-280 167.429v0.571l-0.571-0.571-0.571 0.571v-0.571l-279.429-167.429v-61.714l84 54.857 195.429-162.286v-1.143l0.571 0.571 0.571-0.571v1.143l196 162.286zM316.571 67.429l195.429 162.857-282.286 173.714-193.143-154.286zM794.286 404l193.143 154.857-279.429 182.286-196-162.857zM708 67.429l279.429 182.286-193.143 154.286-282.286-173.714z"
                ></path>
              </svg>
              <svg viewBox="0 0 1024 1024" class="first-steps-icon02" v-else>
                <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
              </svg>
            </div>
            <div class="first-steps-line7"></div>
          </div>
          <div class="first-steps-container05">
            <h1 class="first-steps-text04">Produto</h1>
            <span class="first-steps-text05">
              <span v-if="!hasProduct">Adicione seu primeiro produto.</span>
              <span v-else>Primeiro produto adicionado.</span>
              <br />
            </span>
          </div>
        </div>
      </div>
      <v-row class="publish-row">
        <h3 class="font-weight-bold">
          Parece que está tudo em ordem, bora publicar sua loja?! 🚀
        </h3>
        <v-btn
          height="48"
          class="button btn-border order-2 dark dense btn-right mt-8"
          :disabled="enabledPublish"
          @click="publishStore"
        >
          Publicar loja
        </v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
export default {
  name: "FirstSteps",
  props: {},
  mixins: [LojasGerenciarMixins],
  data() {
    return {
      idloja: "",
      tipo_pessoa: "",

      razao_social: "",
      cnpj: "",

      cep: "",
      pais: "",
      estado: "",
      cidade: "",
      bairro: "",
      logradouro: "",
      complemento: "",

      segmento: "",
      regional: "",
      status: "",
      nome_loja: "",
      tipo_slug: "",
      slug_loja: "",

      nome: "",
      cpf: "",
      rg: "",
      rg_orgao: "",
      email: "",
      celular: "",

      nome_titular: "",
      banco: "",
      agencia: "",
      numero_conta: "",
      digito_conta: "",
      forma_pag: [],

      tema_cor_primaria: "",
      tema_cor_secundaria: "",

      contato_email: "",
    };
  },
  computed: {
    enabledPublish() {
      if (
        this.hasRegisterData &&
        this.hasReceiveData &&
        this.hasPaymentData &&
        this.hasThemeData &&
        this.hasPlusConfigData &&
        this.hasProduct
      )
        return false;
      return true;
    },
    hasRegisterData() {
      if (this.tipo_pessoa === "JURIDICA") {
        if (
          this.razao_social !== "" &&
          this.cnpj !== "" &&
          this.cep !== "" &&
          this.pais !== "" &&
          this.estado !== "" &&
          this.cidade !== "" &&
          this.bairro !== "" &&
          this.logradouro !== "" &&
          this.segmento !== "" &&
          this.regional !== "" &&
          this.status !== "" &&
          this.nome_loja !== "" &&
          this.tipo_slug === "CUSTOM" &&
          this.slug_loja !== "" &&
          this.nome !== "" &&
          this.cpf !== "" &&
          this.rg !== "" &&
          this.rg_orgao !== "" &&
          this.email !== "" &&
          this.celular !== ""
        )
          return true;
        return false;
      } else {
        if (
          this.nome_loja !== "" &&
          this.cep !== "" &&
          this.pais !== "" &&
          this.estado !== "" &&
          this.cidade !== "" &&
          this.bairro !== "" &&
          this.logradouro !== "" &&
          this.segmento !== "" &&
          this.regional !== "" &&
          this.status !== "" &&
          this.tipo_slug === "CUSTOM" &&
          this.slug_loja !== "" &&
          this.nome !== "" &&
          this.cpf !== "" &&
          this.rg !== "" &&
          this.rg_orgao !== "" &&
          this.email !== "" &&
          this.celular !== ""
        )
          return true;
        return false;
      }
    },
    hasReceiveData() {
      if (
        this.nome_titular !== "" &&
        this.banco !== "" &&
        this.agencia !== "" &&
        this.numero_conta !== "" &&
        this.digito_conta !== ""
      )
        return true;
      return false;
    },
    hasPaymentData() {
      if (this.forma_pag.length > 0) return true;
      return false;
    },
    hasThemeData() {
      if (this.tema_cor_primaria !== "" && this.tema_cor_secundaria !== "")
        return true;
      return false;
    },
    hasPlusConfigData() {
      if (this.contato_email !== "") return true;
      return false;
    },
    hasProduct() {
      if (this.$produtos_gerenciar.produtos.length > 0) return true;
      return false;
    },
  },
  methods: {
    backToDash() {
      this.$router.push({ name: "home" });
    },
    goTo(param) {
      switch (param) {
        case "cadastro-loja": {
          this.$loja_gerenciar.lojaAddOrEdit = "edit";
          this.$router.push(
            "/lojas/gerenciar/editar/cadastro-loja/" +
              this.$axios.getLocal("session")?.data?.idloja
          );
          break;
        }
        case "recebimentos-loja": {
          this.$loja_gerenciar.lojaAddOrEdit = "edit";
          this.$router.push(
            "/lojas/gerenciar/editar/recebimentos-loja/" +
              this.$axios.getLocal("session")?.data?.idloja
          );
          break;
        }
        case "pagamentos-loja": {
          this.$loja_gerenciar.lojaAddOrEdit = "edit";
          this.$router.push(
            "/lojas/gerenciar/editar/pagamentos-loja/" +
              this.$axios.getLocal("session")?.data?.idloja
          );
          break;
        }
        case "tema-loja": {
          this.$loja_gerenciar.lojaAddOrEdit = "edit";
          this.$router.push(
            "/lojas/gerenciar/editar/tema-loja/" +
              this.$axios.getLocal("session")?.data?.idloja
          );
          break;
        }
        case "configs-loja": {
          this.$loja_gerenciar.lojaAddOrEdit = "edit";
          this.$router.push(
            "/lojas/gerenciar/editar/configs-loja/" +
              this.$axios.getLocal("session")?.data?.idloja
          );
          break;
        }
        case "produto": {
          this.$router.push("/produtos/gerenciar/cadastrar");
          break;
        }
      }
    },
    getStore() {
      let filtros = [
        {
          campo: "loja.idloja",
          tipo: "string",
          valor: this.$axios.getLocal("session")?.data?.idloja,
        },
      ];
      this.$axios
        .post(this.ENDPOINTS.LISTAR_LOJAS, JSON.stringify({ filtros }))
        .then(response => {
          let dados = response[0];
          this.idloja = dados.idloja;
          // dados cadastrias
          this.tipo_pessoa = dados.tipo_pessoa ? dados.tipo_pessoa : "JURIDICA";
          this.razao_social = dados.razao_social ? dados.razao_social : "";
          this.cnpj = dados.cnpj ? dados.cnpj : "";

          this.cep = dados.end_cep ? dados.end_cep : "";
          this.pais = dados.end_pais ? dados.end_pais : "";
          this.estado = dados.end_estado ? dados.end_estado : "";
          this.cidade = dados.end_cidade ? dados.end_cidade : "";
          this.bairro = dados.end_bairro ? dados.end_bairro : "";
          this.logradouro = dados.end_logradouro ? dados.end_logradouro : "";
          this.complemento = dados.end_complemento ? dados.end_complemento : "";

          this.segmento = dados.idsegmento ? dados.idsegmento : "";
          this.regional = dados.idregional ? dados.idregional : "";
          this.status = dados.status ? dados.status : "";
          this.nome_loja = dados.nome_loja ? dados.nome_loja : "";
          this.slug_loja = dados.slug ? dados.slug : "";
          (this.tipo_slug = dados.tipo_slug ? dados.tipo_slug : "DEFAULT"),
            (this.nome = dados.representante_nome
              ? dados.representante_nome
              : "");
          this.cpf = dados.representante_cpf ? dados.representante_cpf : "";
          this.rg = dados.representante_rg ? dados.representante_rg : "";
          this.rg_orgao = dados.representante_rg_orgao
            ? dados.representante_rg_orgao
            : "";
          this.email = dados.representante_email
            ? dados.representante_email
            : "";
          this.celular = dados.celular ? dados.celular : "";

          // dados rebecimento
          (this.nome_titular = dados.nome_titular ? dados.nome_titular : ""),
            (this.banco = dados.banco ? dados.banco : ""),
            (this.agencia = dados.agencia ? dados.agencia : ""),
            (this.numero_conta = dados.numero_conta ? dados.numero_conta : ""),
            (this.digito_conta =
              dados.digito_conta || dados.digito_conta === 0
                ? dados.digito_conta
                : ""),
            // dados pagamento
            (this.forma_pag = dados.nidforma_pag
              ? dados.nidforma_pag.split(";")
              : []);

          // dados tema
          this.tema_cor_primaria = dados.tema_cor_primaria
            ? dados.tema_cor_primaria
            : "#1976D2";
          this.tema_cor_secundaria = dados.tema_cor_secundaria
            ? dados.tema_cor_secundaria
            : "#1976D2";

          this.contato_email = dados.contato_email ? dados.contato_email : "";

          this.$loja_gerenciar.cadastro.id_loja = dados.idloja;
          this.$loja_gerenciar.cadastro.id_tema = dados.idtema;

          // DADOS CADASTRAIS
          this.$loja_gerenciar.cadastro.dados_cadastrais.pessoa =
            dados.tipo_pessoa ? dados.tipo_pessoa : "JURIDICA";
          this.$loja_gerenciar.cadastro.dados_cadastrais.razao_social =
            dados.razao_social ? dados.razao_social : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.cnpj = dados.cnpj
            ? dados.cnpj
            : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.pais = dados.end_pais
            ? dados.end_pais
            : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.cep = dados.end_cep
            ? dados.end_cep
            : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.logradouro =
            dados.end_logradouro ? dados.end_logradouro : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.numero =
            dados.end_numero ? dados.end_numero : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.complemento =
            dados.end_complemento ? dados.end_complemento : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.bairro =
            dados.end_bairro ? dados.end_bairro : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.estado =
            dados.end_estado ? dados.end_estado : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.cidade =
            dados.end_cidade ? dados.end_cidade : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.idloja_neo =
            dados.idloja_neo ? dados.idloja_neo : "";

          if (dados.tipo_pessoa == "JURIDICA") {
            // PESSOA JURIDICA
            this.$loja_gerenciar.cadastro.dados_cadastrais.nome =
              dados.representante_nome ? dados.representante_nome : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.email =
              dados.representante_email ? dados.representante_email : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.cpf =
              dados.representante_cpf ? dados.representante_cpf : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.rg =
              dados.representante_rg ? dados.representante_rg : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.rg_orgao =
              dados.representante_rg_orgao ? dados.representante_rg_orgao : "";

            // DOCUMENTOS
            let documento = [];

            if (dados.pdf_documento) {
              documento.push({ pdf_documento: dados.pdf_documento });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pj =
                documento;
            }

            if (dados.pdf_contrato_social) {
              documento.push({
                pdf_contrato_social: dados.pdf_contrato_social,
              });
              this.$loja_gerenciar.$loja_gerenciar.cadastro.documentos.documento_array_pj =
                documento;
            }

            if (dados.pdf_comprovante_endereco) {
              documento.push({
                pdf_comprovante_endereco: dados.pdf_comprovante_endereco,
              });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pj =
                documento;
            }

            if (dados.pdf_procuracao) {
              documento.push({ pdf_procuracao: dados.pdf_procuracao });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pj =
                documento;
            }
          } else {
            // PESSOA FISICA
            this.$loja_gerenciar.cadastro.dados_cadastrais.nome = dados.nome
              ? dados.nome
              : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.cpf = dados.cpf
              ? dados.cpf
              : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.rg = dados.rg
              ? dados.rg
              : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.rg_orgao =
              dados.rg_orgao ? dados.rg_orgao : "";
            this.$loja_gerenciar.cadastro.dados_cadastrais.email = dados.email
              ? dados.email
              : "";

            // DOCUMENTOS
            let documento = [];

            if (dados.pdf_documento) {
              documento.push({ pdf_documento: dados.pdf_documento });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pf =
                documento;
            }

            if (dados.pdf_contrato_social) {
              documento.push({
                pdf_contrato_social: dados.pdf_contrato_social,
              });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pf =
                documento;
            }

            if (dados.pdf_comprovante_endereco) {
              documento.push({
                pdf_comprovante_endereco: dados.pdf_comprovante_endereco,
              });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pf =
                documento;
            }

            if (dados.pdf_procuracao) {
              documento.push({ pdf_procuracao: dados.pdf_procuracao });
              this.$loja_gerenciar.cadastro.documentos.documento_array_pf =
                documento;
            }
          }

          this.$loja_gerenciar.cadastro.dados_cadastrais.celular = dados.celular
            ? dados.celular
            : "";

          this.$loja_gerenciar.cadastro.dados_cadastrais.segmento =
            dados.idsegmento ? dados.idsegmento : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.regional =
            dados.idregional ? dados.idregional : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.agente_vinculado =
            dados.idagente ? dados.idagente : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.status = dados.status
            ? dados.status
            : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.nome_loja =
            dados.nome_loja ? dados.nome_loja : "";
          this.$loja_gerenciar.cadastro.dados_cadastrais.slug_loja = dados.slug
            ? dados.slug
            : "";
          (this.$loja_gerenciar.cadastro.dados_cadastrais.tipo_slug =
            dados.tipo_slug ? dados.tipo_slug : "DEFAULT"),
            // COMISSÃO E ANTECIPAÇÃO
            (this.$loja_gerenciar.cadastro.comissao_antecipacao.comissao =
              dados.comissao
                ? dados.comissao_porcentagem_custom != 0
                  ? "personalizada"
                  : dados.comissao
                : "7.4");
          this.$loja_gerenciar.cadastro.comissao_antecipacao.porcentagem_customizada =
            dados.comissao_porcentagem_custom
              ? dados.comissao_porcentagem_custom
              : "";
          this.$loja_gerenciar.cadastro.comissao_antecipacao.antecipacao =
            dados.antecipacao_taxa ? dados.antecipacao_taxa : "";
          this.$loja_gerenciar.cadastro.comissao_antecipacao.taxa_personalizada =
            dados.antecipacao_taxa_custom ? dados.antecipacao_taxa_custom : "";
          this.$loja_gerenciar.cadastro.comissao_antecipacao.dias_antecipacao =
            dados.antecipacao_dias ? dados.antecipacao_dias : "";
          this.$loja_gerenciar.cadastro.comissao_antecipacao.taxa_mes =
            dados.antecipacao_taxa ? dados.antecipacao_taxa : "";
          this.$loja_gerenciar.cadastro.comissao_antecipacao.observacoes =
            dados.observacoes ? dados.observacoes : "";

          // DADOS BANCARIOS
          this.$loja_gerenciar.cadastro.dados_bancarios.nome_titular =
            dados.nome_titular ? dados.nome_titular : "";
          this.$loja_gerenciar.cadastro.dados_bancarios.banco = dados.banco
            ? dados.banco
            : "";
          this.$loja_gerenciar.cadastro.dados_bancarios.agencia = dados.agencia
            ? dados.agencia
            : "";
          this.$loja_gerenciar.cadastro.dados_bancarios.tipo_conta =
            dados.tipo_conta ? dados.tipo_conta : "CORRENTE";
          this.$loja_gerenciar.cadastro.dados_bancarios.numero_conta =
            dados.numero_conta ? dados.numero_conta : "";
          this.$loja_gerenciar.cadastro.dados_bancarios.digito_conta =
            dados.digito_conta || dados.digito_conta === 0
              ? dados.digito_conta
              : "";
          this.$loja_gerenciar.cadastro.dados_bancarios.forma_pag =
            dados.nidforma_pag ? dados.nidforma_pag.split(";") : [];

          // CONTRATOS
          // this.$loja_gerenciar.$loja_gerenciar.cadastro.contratos.template = ''

          // TEMA
          this.$loja_gerenciar.cadastro.tema.cor_primaria =
            dados.tema_cor_primaria ? dados.tema_cor_primaria : "#1976D2";
          this.$loja_gerenciar.cadastro.tema.cor_secundaria =
            dados.tema_cor_secundaria ? dados.tema_cor_secundaria : "#1976D2";
          this.$loja_gerenciar.cadastro.tema.marketing_imply_ativo =
            dados.marketing_imply_ativo ? dados.marketing_imply_ativo : false;

          if (dados.tema_logotipo) {
            this.$loja_gerenciar.cadastro.tema.logotipo.imagem =
              dados.tema_logotipo;
            this.$loja_gerenciar.cadastro.tema.logotipo.have = true;
          }

          if (dados.tema_banners) {
            const arrayOfObj = Object.entries(dados.tema_banners).map(e => ({
              [e[0]]: e[1],
            }));

            this.$loja_gerenciar.cadastro.tema.banners_array = arrayOfObj;
          }

          this.$loja_gerenciar.cadastro.tema.tem_traducao =
            dados.tema_banner_texto_traducao
              ? dados.tema_banner_texto_traducao
              : false;

          if (dados.tema_banner_texto.indexOf("<pt_BR>") > -1) {
            this.$loja_gerenciar.cadastro.tema.texto_banner =
              dados.tema_banner_texto_traducao
                ? dados.tema_banner_texto.substring(
                    dados.tema_banner_texto.indexOf("<pt_BR>") + 7,
                    dados.tema_banner_texto.indexOf("</pt_BR>")
                  )
                : "";
            this.$loja_gerenciar.cadastro.tema.texto_banner_en =
              dados.tema_banner_texto_traducao
                ? dados.tema_banner_texto.substring(
                    dados.tema_banner_texto.indexOf("<en_US>") + 7,
                    dados.tema_banner_texto.indexOf("</en_US>")
                  )
                : "";
            this.$loja_gerenciar.cadastro.tema.texto_banner_es =
              dados.tema_banner_texto_traducao
                ? dados.tema_banner_texto.substring(
                    dados.tema_banner_texto.indexOf("<es_ES>") + 7,
                    dados.tema_banner_texto.indexOf("</es_ES>")
                  )
                : "";
          } else {
            this.$loja_gerenciar.cadastro.tema.texto_banner =
              dados.tema_banner_texto;
          }

          // CONFIGURAÇÕES DE REDE
          this.$loja_gerenciar.cadastro.configuracoes_rede.rede_vendas =
            dados.rede_vendas ? dados.rede_vendas : "PRIVADA";
          this.$loja_gerenciar.cadastro.configuracoes_rede.rede_privada =
            dados.rede_privada ? dados.rede_privada.split(";") : [];
          this.$loja_gerenciar.cadastro.configuracoes_rede.canal_venda =
            dados.rede_privada ? dados.rede_privada.split(";") : [];
          // this.$loja_gerenciar.$loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada = [],
          // this.$loja_gerenciar.$loja_gerenciar.cadastro.configuracoes_rede.perfis_pdv = ''

          // CONFIGURAÇÕES ADICIONAIS
          if (this.lojaAddOrEdit && dados.faq != undefined) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.perguntas_frequentes =
              dados.faq;
          }
          if (this.lojaAddOrEdit && dados.redes_sociais != undefined) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.redes_sociais =
              dados.redes_sociais;
          }
          if (this.lojaAddOrEdit && dados.contato != undefined) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato =
              dados.contato;
          }
          if (this.lojaAddOrEdit && dados.politicas != undefined) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.politicas =
              dados.politicas;
          }
          if (this.lojaAddOrEdit && dados.contato_sac) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato_sac =
              dados.contato_sac;
          }
          if (this.lojaAddOrEdit && dados.contato_email) {
            this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato_email =
              dados.contato_email;
          }
        });
    },
    publishStore() {
      this.$loja_gerenciar.alterarLoja(this.idloja, true);
    },
  },
  beforeMount() {
    this.getStore();
    this.$produtos_gerenciar.getProdutos(
      this.$axios.getLocal("session")?.data?.loja
    );
  },
};
</script>

<style scoped>
.first-steps-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #d9d9d9;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  fill: var(--dl-color-gray-500);
}

.back-button:hover {
  cursor: pointer;
  opacity: 1;
}

.publish-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px !important;
  max-height: 200px !important;
  padding-top: 5rem;
}

.clickable:hover {
  cursor: pointer;
}

.non-clickable {
  pointer-events: none;
}

.first-steps-container01 {
  width: 100%;
  height: 1003px;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  align-self: center;
  max-height: 100%;
  min-height: 100%;
  align-items: center;
  padding-right: 48px;
  flex-direction: column;
  justify-content: center;
}

.first-steps-title {
  color: #000000;
  font-size: 3rem;
}

.first-steps-subtitle {
  font-size: 1.75rem;
  max-width: 600px;
  text-align: center;
  margin: 1rem 0;
  color: #999999;
}

.first-steps-container02 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-top: 30px;
  flex-direction: row;
  justify-content: center;
}

.first-steps-step {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.first-steps-container03 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 1rem;
  padding-left: 2px;
  padding-right: 2px;
  flex-direction: row;
  justify-content: center;
}

.first-steps-line {
  flex: 1;
  height: 0px;
  display: flex;
  align-items: flex-start;
  border-color: transparent;
  border-style: dashed;
  border-width: 2px;
  flex-direction: row;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}

.first-steps-container04 {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  flex-direction: row;
  justify-content: center;
  background-color: #f5f5f5ff;
}

.first-steps-icon {
  fill: #ff7c4c;
  width: 24px;
  height: 24px;
}

.first-steps-icon02 {
  fill: #4ad313;
  width: 24px;
  height: 24px;
}

.first-steps-line1 {
  flex: 1;
  height: 0px;
  display: flex;
  align-items: flex-start;
  border-color: #000000;
  border-style: dashed;
  border-width: 2px;
  flex-direction: row;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}

.first-steps-container05 {
  display: flex;
  align-items: center;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  padding-bottom: 1rem;
}

.first-steps-text04 {
  font-size: 1.5rem;
  text-align: center;
  font-weight: 500;
  margin-bottom: 1rem;
}

.first-steps-text05 {
  color: #595959;
  font-size: 0.825rem;
  text-align: center;
}

.first-steps-line2 {
  flex: 1;
  height: 0px;
  display: flex;
  align-items: flex-start;
  border-color: #000000;
  border-style: dashed;
  border-width: 2px;
  flex-direction: row;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}

.first-steps-line7 {
  flex: 1;
  height: 0px;
  display: flex;
  align-items: flex-start;
  border-color: transparent;
  border-style: dashed;
  border-width: 2px;
  flex-direction: row;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}

@media (max-width: 1366px) {
  .first-steps-container01 {
    justify-content: flex-start;
  }
}
</style>
